// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2aR2E","alertIcon":"ConfirmModal_alertIcon__3ruze"};